import { HttpContextToken, HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { ErrorComponent } from "./error/error.component";
import { ErrorService } from "./error/error.service";
import { AuthService } from "./auth/auth.service";
import { ApiUrlService } from "./core/api-url";

export const SUPPRESS_GLOBAL_ERROR_DIALOG = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private dialog: MatDialog,
    private errorService: ErrorService,
    private authService: AuthService,
    private apiUrl: ApiUrlService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const isBackend = this.apiUrl.isBackendRequest(req.url);
        if (isBackend && error?.status === 401) {
          // Public pages can make optional authenticated requests (for example,
          // role-permissions) while no user is signed in. Treating those expected
          // 401s as an expired session calls signOut and can clear a cookie that
          // was just created by a concurrent login.
          if (this.authService.getIsAuth()) {
            this.authService.handleSessionExpired();
          }
          return throwError(() => error);
        }
        let errorMessage = "An unknown error occurred!";
        if (error?.error?.message) {
          errorMessage = error.error.message;
        }
        if (error?.error?.error?.message) {
          errorMessage = error.error.error.message;
        }
        const isHandledSchedulerValidation =
          isBackend &&
          req.url.includes('/schedule/generator-milestone') &&
          Array.isArray(error?.error?.issues);
        const isHandledScheduleEditConflict =
          isBackend &&
          req.url.includes('/schedule/') &&
          req.url.endsWith('/staff') &&
          error?.status === 409 &&
          ['COURT_COLLISION', 'SHARED_PLAYER_CONFLICT'].includes(error?.error?.code);
        const suppressGlobalErrorDialog = req.context.get(SUPPRESS_GLOBAL_ERROR_DIALOG);
        if (!isHandledSchedulerValidation && !isHandledScheduleEditConflict && !suppressGlobalErrorDialog) {
          this.dialog.open(ErrorComponent, { data: { message: errorMessage } });
        }
        return throwError(() => error);
      })
    );
  }
}
